
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reels/[id]",
      function () {
        return require("private-next-pages/reels/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reels/[id]"])
      });
    }
  